<template>
  <div class="fixed top-0 left-0 w-screen flex justify-center h-full">
    <Icon iconClass="fas fa-spinner fa-pulse fa-6x" class="self-center" />
  </div>
</template>
<script>
export default {}
</script>
